import { logWrapper } from '../../utils';

export default {
  additionalFieldService: [
    'runtimeConstant',
    function (runtimeConstant) {
      function setTemplate(f, field) {
        switch (field.AdditionalField.IdFieldType) {
          case 1: //Boolean
            f.template = 'views/partials/additionalFields/boolean.html';
            f.value = Boolean(field.Value);
            break;
          case 2: //Integer Number
            f.template = 'views/partials/additionalFields/integer.html';
            f.value = Number(field.Value);
            break;
          case 3: //Text
            f.template = 'views/partials/additionalFields/text.html';
            break;
          case 4: //Decimal
            f.template = 'views/partials/additionalFields/decimal.html';
            f.value = parseFloat(field.Value);
            break;
          case 5: //Text Long
            f.template = 'views/partials/additionalFields/text-long.html';
            break;
          case 6: //Date
            f.template = 'views/partials/additionalFields/date.html';
            break;
          case 7: //List
            f.template = 'views/partials/additionalFields/list.html';
            break;
        }
      }

      function parseFlexibleDate(value) {
        if (!value) return null;

        if (value instanceof Date) return value;

        if (/^\d{4}-\d{2}-\d{2}/.test(value)) {
          const date = new Date(value);
          return isNaN(date.getTime()) ? null : date;
        }

        if (value.includes('/')) {
          let datePart = value.split(' ')[0];
          let parts = datePart.split('/').map(Number);

          if (parts.length !== 3) return null;

          let first = parts[0];
          let second = parts[1];
          let year = parts[2];

          let day, month;

          if (first > 12) {
            // dd/MM/yyyy (Brasil)
            day = first;
            month = second;
          } else {
            // MM/dd/yyyy (EUA)
            month = first;
            day = second;
          }

          const date = new Date(year, month - 1, day);
          return isNaN(date.getTime()) ? null : date;
        }

        return null;
      }

      function additionalField(field) {
        this.fieldType = field.AdditionalField.IdFieldType;
        this.validationType = field.AdditionalField.ValidationType;

        this.id = field.AdditionalField.Id;
        this.name = field.AdditionalField.Name;
        this.description = field.AdditionalField.Description;

        this.required = field.IsRequired === null ? false : field.IsRequired;

        this.idList = null;
        this.items = null;

        if (field.AdditionalField.IdList && field.AdditionalField.List) {
          this.idList = field.AdditionalField.IdList;
          this.items = field.AdditionalField.List.Items;
        }

        if (field.AdditionalField.IdFieldType === 6 && field.Value) {
          this.value = parseFlexibleDate(field.Value);
        } else {
          this.value = field.Value;
        }

        setTemplate(this, field);
      }

      function run() {
        try {
          return additionalField;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
